import { Component, OnInit, Input, output, inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'app-options-modal',
    templateUrl: './options-modal.component.html',
    styleUrls: ['./options-modal.component.scss'],
    imports: []
})
export class OptionsModalComponent implements OnInit {
  private modalService = inject(NgbModal);

  @Input()
  modalTitle = ''

  @Input()
  options = new Array<string>();

  readonly itemSelected = output<string>();

  ngOnInit() {
  }

  openModal(content) {
    this.modalService.open(content, { size: 'lg' }).result.then((result) => {
      this.itemSelected.emit(result);
    }, (reason) => {
      // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

}
